import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductsRoutingModule } from './products-routing.module';
import { ProductsComponent } from './products.component';
import { NgZorroAntdModule, NzAvatarModule, NzButtonModule, NzCommentModule, NzDatePickerModule, NzDividerModule, NzDropDownModule, NzFormModule, NzGridModule, NzIconModule, NzInputModule, NzInputNumberModule, NzListModule, NzPaginationModule, NzSelectModule, NzSpinModule, NzTableModule, NzTabsModule, NzTagModule, NzToolTipModule, NzUploadModule } from '../utilities/ng-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';
 import { ProductOffersComponent } from './product-offers/product-offers.component';
 import { AddLocationProductComponentComponent } from './location-product/add-location-product-component/add-location-product-component.component';
import { LocationProductComponentComponent } from './location-product/location-product-component.component';
import { CreateMerchantProductComponent } from './merchant-product/create-merchant-product/create-merchant-product.component';
import { NewMerchantProductComponent } from './merchant-product/new-merchant-product/new-merchant-product.component';
import { EditMerchantProductComponent } from './merchant-product/edit-merchant-product/edit-merchant-product.component';
import { AvailableLocationComponent } from './merchant-product/available-location/available-location.component';
import { AssignLocationComponent } from './merchant-product/assign-location/assign-location.component';
import { MerchantProductComponent } from './merchant-product/merchant-product.component';
import { SecurePipeModule } from 'src/app/utilities/secure.module';

 

@NgModule({
    declarations: [ProductsComponent, CreateMerchantProductComponent, ProductOffersComponent, LocationProductComponentComponent, AddLocationProductComponentComponent, NewMerchantProductComponent, EditMerchantProductComponent, AvailableLocationComponent, AssignLocationComponent, MerchantProductComponent],
    imports: [
        CommonModule,
        ProductsRoutingModule,
        NgZorroAntdModule,
        FormsModule,
        MomentModule,
        ReactiveFormsModule,
        SecurePipeModule,
        NzFormModule,
         NzSelectModule,
        NzDropDownModule,
        NzTableModule,
        NzTagModule,
        NzButtonModule,
        NzGridModule,
        NzToolTipModule,
        NzPaginationModule,
        NzDatePickerModule,
        NzInputModule,
        NzIconModule,
        NzDividerModule,
        NzUploadModule,
        NzInputNumberModule,
        NzSpinModule,
        NzTabsModule,
        NzListModule,
        NzCommentModule,
        NzAvatarModule
    ],
    exports: [ProductsComponent, CreateMerchantProductComponent, ProductOffersComponent, LocationProductComponentComponent, AddLocationProductComponentComponent, NewMerchantProductComponent, EditMerchantProductComponent, AvailableLocationComponent, AssignLocationComponent, MerchantProductComponent]
})
export class ProductsModule { }
